export const API_ENDPOINT_MASTERLAYOUT_CLIENT_SERVER = `${process.env.REACT_APP_API_URL}/misc/recon/za/airline/meta`//new
export const API_ENDPOINT_MASTERLAYOUT_CLIENT_SERVER_New = `${process.env.REACT_APP_API_URL}/misc/recon/za/airline/metaNewTable`
export const API_ENDPOINT_SCHEMA_LIST_NEW = `${process.env.REACT_APP_API_URL}/agtable/schemas/listNew`
